module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/2802fceba59929afdf19ed100f513c67.svg";